var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { ChatMessage } from '../ChatMessage';
const ChatLogList = styled('ul') `
    list-style-type: none;
    padding: 0;
`;
export const ChatLog = (props) => {
    const { messages, onTimestampClick } = props, rest = __rest(props, ["messages", "onTimestampClick"]);
    return (_jsx(ChatLogList, Object.assign({}, rest, { children: messages.map((messageProps, index) => (_jsx("li", { children: _jsx(ChatMessage, Object.assign({}, messageProps, { onTimestampClick: (event) => onTimestampClick === null || onTimestampClick === void 0 ? void 0 : onTimestampClick(event, messageProps) })) }, index))) })));
};
